import { Navigate, useLocation } from "react-router-dom";
import { useAuth, isStaff } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children, requirePOS = false }) {
  const { user, booting } = useAuth();
  const loc = useLocation();

  if (booting) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background" data-testid="app-boot">
        <div className="animate-pulse text-muted-foreground">Loading Babu Baazar…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" state={{ from: loc.pathname }} replace />;
  if (!isStaff(user)) {
    return (
      <div className="min-h-screen flex items-center justify-center p-8 text-center" data-testid="not-staff">
        <div>
          <h2 className="text-2xl font-display mb-2">Staff access required</h2>
          <p className="text-muted-foreground mb-4">This section is for Babu Baazar staff only.</p>
          <a href="/" className="text-primary hover:underline text-sm">← Back to shop</a>
        </div>
      </div>
    );
  }
  return children;
}
